import { defineMessages } from 'react-intl';

export default defineMessages({
  pageTitle: {
    id: 'features.userTypeRecovery.pageTitle',
    defaultMessage: 'Tipologia utente',
    description: 'Title of the user-type recovery page',
  },
  pageSubtitle: {
    id: 'features.userTypeRecovery.pageSubtitle',
    defaultMessage:
      'Scegli la tipologia di persona per la quale recuperare l’username',
    description: 'Subtitle of the user-type recovery page',
  },
  disclaimer: {
    id: 'features.retrieveUsername.disclaimer',
    defaultMessage: 'Torna alla ',
  },
  labelNaturalPersonRadioButton: {
    id: 'features.userTypeRecovery.labelRecoveryUsernameRadioButton',
    defaultMessage: 'Persona fisica',
    description: 'Label of recovery user-type radio button',
  },
  labelLegalPersonRadioButton: {
    id: 'features.userTypeRecovery.labelRecoveryPasswordRadioButton',
    defaultMessage: 'Persona giuridica/Società fiduciaria',
    description: 'Label of recovery user-type radio button',
  },
});
